import React, { useContext, useMemo } from 'react';
import { Link } from 'anf-core-react';
import ShopSimilarIcon from './ShopSimilarIcon';
import SwitchTestContext from '../../contexts/SwitchTestContext';
import BrowserContext from '../../contexts/BrowserContext';
import buildQueryString from '../../tools/buildQueryString';
import { removeStoredQuickview } from '../StoreQuickviewProvider/StoreQuickviewProvider';

export default function ShopSimilar({ collectionData, cta, label }) {
  const SwitchTestState = useContext(SwitchTestContext);
  const isBrowser = useContext(BrowserContext);

  const pdpShopSimilar = SwitchTestState['pdp-shop-similar'];

  const { skus, shopSimilarUrl, activeProduct: { productId, colorFamily } = {} } = collectionData;

  const hasUnavailableSku = useMemo(
    () => skus.some((sku) => sku.productId === productId && (sku.inventoryStatus?.toLowerCase() === 'unavailable' || sku.inventory <= 0)),
    [skus, productId],
  );

  const url = useMemo(() => {
    if (!shopSimilarUrl || !isBrowser) return '';

    const queryParams = { facet: `colorFamily:(${colorFamily})`, pagefm: 'navigation-shop similar' };
    const queryUrl = colorFamily ? buildQueryString(queryParams) : '';

    return `${shopSimilarUrl}?${queryUrl}`;
  }, [shopSimilarUrl, isBrowser, colorFamily]);

  if (!(pdpShopSimilar && hasUnavailableSku && url)) return null;

  return (
    <div className="shop-similar__container">
      <ShopSimilarIcon />
      <span className="shop-similar__label">{label}</span>
      <Link
        href={url}
        className="shop-similar__cta"
        onClick={() => removeStoredQuickview()}
      >
        {cta}
      </Link>
    </div>
  );
}
